import {cljjs, jsclj, resolveGoogExport} from 'dgetz/tsclj'

export function copyright({color, ccpa, minimal, sendBang, tag = null, agentDisclaimer = null}) {
  const {copyright} = resolveGoogExport('ladder.footer')
  return copyright(jsclj({
    color: color, ccpa: ccpa, 'minimal?': minimal, 'send!': sendBang, tag: tag, 'agent-disclaimer?': agentDisclaimer,
  }))
}

export function disclaimerText({agentDisclaimer = null}) {
  const {disclaimer_text} = resolveGoogExport('ladder.footer')
  return cljjs(disclaimer_text(jsclj({
    'agent-disclaimer?': agentDisclaimer,
  })))
}
